import { IonTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { MachineProgramStatus } from '../../../../../components/machine/machine-program-status';
import { useMachineContext } from '../../../../../pages/machine/machine-context-provider';

export interface AppTitleProps {
  title: string;
}

const AppPageTitle = (props: AppTitleProps): ReactElement => {
  const { title } = props;
  const context = useMachineContext();

  return (
    <>
      <IonTitle className="scratchpad-header">
        {title}
        <div className="subtitle header-program-status">
          <MachineProgramStatus machine={context.machine} />
        </div>
      </IonTitle>
    </>
  );
};

export { AppPageTitle };
